<div
  class="main-content table-page table-page--compact inventario-ia-historial-page"
>
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Historial de cambios</h1>
        <p>Bitácora del activo IA #{{ idInventarioIa }} — ISO/IEC 42001.</p>
      </div>

      <div class="table-page__toolbar-actions">
        <button
          type="button"
          mat-raised-button
          class="btn table-page__icon-btn table-page__icon-btn--secondary"
          (click)="regresar()"
          aria-label="Regresar"
        >
          <i class="material-icons">reply</i>
          <span>Regresar</span>
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__table-wrap">
        <table
          class="table-page__table table-page__table--xwide"
          *ngIf="historial.length > 0; else historialEmptyState"
        >
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Acción</th>
              <th>Campo</th>
              <th>Valor anterior</th>
              <th>Valor nuevo</th>
              <th>Usuario</th>
            </tr>
          </thead>
          <tbody>
            <!-- Sin hora: el alta y las bajas son hechos del día, y la hora
                 de captura no le dice nada a quien lee la bitácora. -->
            <tr *ngFor="let h of historial">
              <td>
                <span class="table-page__text">
                  {{ h.fechaCambio | date: "dd/MM/yyyy" }}
                </span>
              </td>
              <td>
                <span
                  class="table-page__status-badge"
                  [ngClass]="badgeClass(h.accion)"
                >
                  {{ h.accion }}
                </span>
              </td>
              <td>
                <strong class="table-page__name">
                  {{ etiquetaCampo(h.campoModificado) }}
                </strong>
              </td>
              <td>
                <span class="table-page__text inventario-ia-historial-page__valor">
                  {{ h.valorAnterior || "—" }}
                </span>
              </td>
              <td>
                <span class="table-page__text inventario-ia-historial-page__valor">
                  {{ h.valorNuevo || "—" }}
                </span>
              </td>
              <td>
                <span class="table-page__text">
                  {{ h.usuarioNombre || h.idUsuario }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #historialEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else historialLoadingState">
            <i class="material-icons">history</i>
            <strong>Sin movimientos registrados</strong>
            <span>Este activo no tiene aún cambios en su bitácora.</span>
          </div>
        </ng-template>

        <ng-template #historialLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando historial…</strong>
          </div>
        </ng-template>
      </div>
    </section>
  </div>
</div>
